import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import OnboardingTasksDrawer from 'features/Onboarding/components/OnboardingTasksDrawer'
import PayCadenceManagement from 'features/PayCadence/components/PayCadenceManagement'
import { PayCadenceResponse } from 'features/PayCadence/payCadenceService'
import { onboardingActions } from 'features/Onboarding/onboardingActions'
import { useDispatch } from 'react-redux'
import Text from 'core-system/Text'

const BoxContainer = styled.div`
  padding: 0;
`

interface PayCadenceDrawerProps {
  isOpen: boolean
  onClose: () => void
}

const PayCadenceDrawer = ({ isOpen, onClose }: PayCadenceDrawerProps) => {
  const dispatch = useDispatch()
  const [cadences, setCadences] = useState<PayCadenceResponse[]>([])
  const [drawerError, setDrawerError] = useState<string | null>(null)

  const handleClose = () => {
    setDrawerError(null)
    onClose()
  }

  const handleCadencesChange = useCallback((loaded: PayCadenceResponse[]) => {
    setCadences(loaded)
    if (loaded.length > 0) {
      setDrawerError(null)
    }
  }, [])

  const completeOnboarding = () => {
    if (cadences.length === 0) {
      setDrawerError('Add at least one pay schedule before confirming.')
      return
    }

    dispatch(
      onboardingActions.updateOnboardingSectionStatus({
        sectionType: 'PAYROLL_DATES',
        status: 'COMPLETED',
      })
    )
    handleClose()
  }

  return (
    <OnboardingTasksDrawer
      isOpen={isOpen}
      onClose={handleClose}
      primaryButton={{
        text: 'Confirm Pay Schedules',
        onClick: completeOnboarding,
      }}
      secondaryButton={{
        text: 'Save and Complete Later',
        onClick: handleClose,
      }}
    >
      <BoxContainer>
        {isOpen && (
          <PayCadenceManagement
            title='Set up your pay schedules'
            description='Customize how and when your team gets paid for each worksite or group.'
            onCadencesChange={handleCadencesChange}
          />
        )}
        {drawerError && (
          <Text variant='body2' color='error' marginTop='1rem'>
            {drawerError}
          </Text>
        )}
      </BoxContainer>
    </OnboardingTasksDrawer>
  )
}

if (process.env.NODE_ENV !== 'production') {
  PayCadenceDrawer.displayName = 'PayCadenceDrawer'
}

export default React.memo(PayCadenceDrawer)
